export const TITLE_WIDTH = '370px';
export const CELL_WIDTH = '270px';
export const MAX_WATERFALLS = 5;
